'use-strict'

/**
 * Ticket:
 * Main interface to create, update or restore a ticket
 */

// import $ from 'jquery'
// import selectorator from './../utils/selectorator'
// import selectText from './../annotations/selectText'
import Ticket from './ticket'
import UserEnv from '@/utils/environment-details'
import store from '@/store'
import { detach } from '@/plugins/detach'
import calculatePosition from '@/utils/calculate-position'
import svgEscape from './lib/svg-escape'
// import getSelector from './lib/get-selector'

export default {
  create (mode, originalEvent, target, documentOffset, annotation) {
    return _createTicket(
      mode,
      originalEvent,
      target,
      documentOffset,
      annotation
    )
  },
  restore (ticketData) {
    return _restoreTicket(ticketData)
  },
  createEditorial (pageId, event, highlight) {
    return _createEditorial(pageId, event, highlight)
  },
  createGeneral (event) {
    return _createGeneral(event)
  },
  detectSelectedText (mode, originalEvent) {
    return _detectSelectedText(mode, originalEvent)
  },
  verifyPageTarget (ticketData) {
    return _verifyPageTarget(ticketData)
  }
}

/**
 * Take event data and create a ticket class,
 * Add ticket to page and save todataSource
 * @param  {Object}  originalEvent  [description]
 * @param  {Object}  target         [description]
 * @param  {[type]}  documentOffset [description]
 * @param  {[type]}  annotation     [description]
 * @return {[type]}                 [description]
 */
const _createTicket = (mode, originalEvent, target, documentOffset) => {
  /**
   * Group ticket data for easy passing between functions
   * @type {Object}
   */

  console.log('createTicket')
  console.dir('target')

  // Get model from store
  const ticketData = {
    ...detach(store.getters['tickets/model'])
  }
  ticketData._org_id = store.getters.orgId
  ticketData._project_id = store.getters.projectId
  ticketData._host_id = store.getters.hostId
  // ticketData._page.push(store.getters.pageId)
  // ticketData._user_id = store.getters.userId
  ticketData._user_strategy_id = store.getters.userStrategyId
  ticketData._status =
    store.getters.userMilestone || store.getters.projectMilestone
  // ticketData._files = []
  ticketData.mode = mode
  ticketData.environment.push(UserEnv.report())
  ticketData.originalEvent = originalEvent
  ticketData.target = svgEscape(target)
  ticketData.documentOffset = documentOffset
  ticketData.selector = getSelector(ticketData.target)
  ticketData.position = calculatePosition(target, originalEvent, documentOffset)
  console.log('@@@@@selector', ticketData.selector)
  console.log('@@@@@tether', ticketData.position)

  let ticketDefaults = {
    _assignedTo: '',
    _type: '',
    _priority: '',
    _status: '',
    _epic: '',
    _sprint: '',
    _parent: ''
  }

  // Apply any user defaults
  if (store.getters.user.ticketDefaults) {
    ticketDefaults = Object.assign(
      {},
      detach(store.getters.user.ticketDefaults)
    )

    // Prevent 'type' selection for assembla
    if (store.getters.strategy.name === 'assembla') {
      const assemblaNewStatusId = store.getters.intTicketTypes.find(
        t => t.name === 'New'
      )
      ticketDefaults._type = assemblaNewStatusId.id || ''
    }
  }

  ticketData._assignedTo = ticketDefaults._assignedTo
  ticketData._type = ticketDefaults._type
  ticketData._priority = ticketDefaults._priority
  if (ticketDefaults._status) {
    ticketData._status = ticketDefaults._status
  }
  if (ticketDefaults._epic) {
    ticketData._epic = ticketDefaults._epic
  }
  if (ticketDefaults._sprint) {
    ticketData._sprint = ticketDefaults._sprint
  }
  if (ticketDefaults._parent) {
    ticketData._parent = ticketDefaults._parent
  }
  console.log('NEW TICKET', ticketData)
  const newTicket = _initTicket(ticketData, true)
  console.log('Really NEW TICKET', ticketData)

  return newTicket
}

/**
 * Take ticket from dataSource and recreate
 * @param  {object} ticketData [description]
 * @return {[type]}            [description]
 */

const _restoreTicket = ticketData => {
  // Find the item on the page and add its target to the data object
  // //console.log('restore Ticket')
  // //console.log(ticketData)
  // _verifyPageTarget(ticketData)

  // ticketData.number = ticketData.info.number

  // Check if description has been updated in promode, and move it so
  // editor will be updated
  // const detailsMdUpdated = ticketData.info.detailsMdUpdated
  // if (detailsMdUpdated) {
  //   ticketData.info.detailsMd = detailsMdUpdated
  // }

  // // //console.log('normalized ticket data')
  // // //console.log(ticketData)
  const ticket = _initTicket(ticketData, false)
  console.log('RESTORED TICKET')
  console.log(ticket)
  ticket.restore(ticketData)

  // Backfill tether for old tickets
  if (!ticket.tether) {
    if (ticket.selector.length && ticket.create.documentOffset) {
      console.log('BACKFILL!!!!!!!')
      const selectorSimmer = simmer(target)
      ticketData.tether = createTether(
        selectorSimmer,
        ticket.create.documentOffset
      )
    }
  }

  console.log('RESTORED TICKET after ')
  console.log(ticket)

  if (ticketData.annotations && ticketData.annotations.length > 0) {
    // We only have 1 type of annotation for now, lets just hack in the text option to keep MVP moving
    // if (ticketData.annotations[0].type === 'selectText') {
    //   // var updatedAnnotation = selectText.restore(
    //   //   ticketData.annotations[0],
    //   //   ticketData._id
    //   // )
    //   // ticketData.annotations[0] = updatedAnnotation
    //   // restoreTarget = updatedAnnotation.el
    // }
    // // Lets try to to reselect elment. right now its actuing funning returning created elements
    // pageTarget = $(updatedAnnotation.outerSelector[0]).find('.picnic-text-select').first()
  }
  // // //console.log('restored ticket')
  // // //console.log(ticket)

  return ticket
}

/**
 * Create the ticket class and add to master array
 * @param  {object} ticketData Data needed to create ticket
 * @return {Ticket}            Ticket Class
 */
const _initTicket = (ticketData, shouldCreateEl) => {
  return new Ticket(ticketData)
}

// const _detectSelectedText = (originalEvent) => {
//     // // //console.log('detect selected text')
//     // var textHighlighted
//     // var textHighlighted = selectText.init(originalEvent)
//     // // //console.log('RETURNED TEXT selected!')
//     // // //console.log(textHighlighted)

//     if(textHighlighted){
//       /**
//        * User has text selected, lets create and `editorial` tickets
//        */
//       textHighlighted.outerSelector = $(textHighlighted.outerEl).getSelector()
//       var elOffset = $(textHighlighted.textSelect).offset()
//       let documentOffset = {
//         x: elOffset.left,
//         y: elOffset.top
//       }
//       const editorialTicket = _createTicket('editorial', originalEvent, undefined, undefined, textHighlighted)
//       editorialTicket.addAnnotation(textHighlighted)
//       return editorialTicket
//     } else {
//       /**
//        * No text selected, lets create a 'generic' ticket
//        */
//        return _createTicket('generic', originalEvent, undefined, undefined, undefined)
//     }
// }

const _createEditorial = (pageId, event, highlight) => {
  /**
   * User has text selected, lets create and `editorial` tickets
   */

  if (!highlight) {
    return false
  }

  // console.log('HIGHLIGHT RETURNED');
  // console.log(highlight)
  // console.log('HIGHLIGHT CONTAINER')
  // console.log(highlight.highlight.getRange());
  const highlightEl = $('.picnic-text-select--is-active').parent()
  // console.log('highlight container')
  console.dir(highlightEl)

  if (highlightEl.length < 1) {
    return false
  }

  const selector = $(highlightEl[0]).getSelector()
  console.dir(selector)

  const offset = $(highlightEl[0]).offset()
  // TODO: See why this needs converted

  if (!offset) {
    return false
  }

  const convertedOffset = {
    x: offset.left,
    y: offset.top
  }
  // console.log(selector);
  const editorialTicket = _createTicket(
    'editorial',
    event,
    highlightEl,
    convertedOffset,
    highlight
  )
  const highlightArchive = createHighlightId(
    pageId,
    highlight.archive,
    highlight.text
  )
  editorialTicket.addHighlight(highlightArchive)
  return editorialTicket
}

const _createGeneral = event => {
  return _createTicket('generic', event, undefined, undefined, undefined)
}

function createHighlightId (pageId, highlightData, text) {
  return {
    _page: pageId,
    archive: highlightData,
    text: text
  }
}

// function _verifyPageTarget (ticketData) {
//   const pageTarget = $(ticketData.selector[0])[0]
//   // //console.log('page target')
//   // //console.log(pageTarget)
//   if (pageTarget) {
//     restoreTarget = pageTarget
//     ticketData.documentOffset = ticketData.offset.fromDocument
//     ticketData.target
//   }
// }
